(function() {
  'use strict';

  angular.module('app.counselor', []);
})();
